import { useTranslation } from "react-i18next";
import useUser from "../hooks/useUser";
import { Email, Workflow } from "../interfaces";
import EmailAliasPopover from "./EmailAliasPopover";

type Props = {
  workflow: Workflow,
  emailConfig: Email;
  onChange: (field: string, value: any) => void,

}

function WorkflowEmailFrom(props: Props) {
  const { user, hasPermission } = useUser();
  const { emailConfig, onChange, workflow } = props;
  const allowEditing = hasPermission(workflow.team, "workflows.edit");
  const { t } = useTranslation();

  if (!user) return null;

  function onSetEmailFromValue(emailFromAlias: string | null, sendFromRunner: boolean) {
    onChange('emailFromAlias', emailFromAlias ?? null);
    onChange('sendFromRunner', sendFromRunner);
  }

  return (
    <div className="flex items-center w-full relative">
      <label className="w-20 font-gilroy font-medium text-gray-500" htmlFor="email-from">{t("From")}</label>
      <EmailAliasPopover
        value={emailConfig.emailFromAlias}
        setValue={onSetEmailFromValue}
        workflow={workflow}
        sendFromRunner={emailConfig.sendFromRunner}
        aliasDisplay={emailConfig.aliasDisplay}
        allowEditing={allowEditing}
        showAliases={emailConfig.emailType === "GMAIL"}
      />
    </div>
  );
}

export default WorkflowEmailFrom;
